import React, { Suspense, lazy } from 'react';
import './css/bootstrap.css';
import './css/config.css';
import './css/index.css';
import './css/responsive.css';
import './css/animate.css';

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Components
import Nav from './components/nav';
import Footer from './components/footer';
import Cookies from './components/cookies';

// Seiten via React.lazy (Lazy Loading)
const Aktuelles = lazy(() => import('./seiten/aktuelles'));
const Alexandra = lazy(() => import('./seiten/alexandra'));
const AmbulandBetreutesWohnen = lazy(() => import('./seiten/ambulant-betreutes-wohnen'));
const Antonia = lazy(() => import('./seiten/antonia'));
const BMH = lazy(() => import('./seiten/BMH'));
const Datenschutz = lazy(() => import('./seiten/datenschutz'));
const Fruehforderung = lazy(() => import('./seiten/frühförderung'));
const HausAmWaldkater = lazy(() => import('./seiten/haus-am-waldkater'));
const Heilpedagogischekindergarden = lazy(() => import('./seiten/heilpädagogische-kindergarden'));
const Start = lazy(() => import('./seiten/index'));
const Impressum = lazy(() => import('./seiten/impressum'));
const IntegrativeKindergartenGruppe = lazy(() => import('./seiten/integrative-kindergarten-gruppe'));
const Katharina = lazy(() => import('./seiten/katharina'));
const Kindergarten = lazy(() => import('./seiten/kindergarten'));
const Kontakt = lazy(() => import('./seiten/kontakt'));
// const Fahrdienst = lazy(() => import('./seiten/fahrdienst'));
const Krippe = lazy(() => import('./seiten/krippe'));
const SchuleAmWaldkater = lazy(() => import('./seiten/schule-am-waldkater'));
const Victoria = lazy(() => import('./seiten/victoria'));
const Wekfeuerwehr = lazy(() => import('./seiten/wekfeuerwehr'));
const Stallpiraten = lazy(() => import('./seiten/stallpiraten'));
const Stellenangebote = lazy(() => import('./seiten/stellenangebote'));
const EigeneWohnung = lazy(() => import('./seiten/eigeneWohnung'));
const Wohnen = lazy(() => import('./seiten/wohnen'));
const Wohntraining = lazy(() => import('./seiten/wohntraining'));
const Verein = lazy(() => import('./seiten/verein'));
const StellenangeboteTv = lazy(() => import('./seiten/stellenangebote_tv'));
const VideoTv = lazy(() => import('./seiten/video_tv'));
const TagespflegeAmWaldkater = lazy(() => import('./seiten/tagespflegeAmWaldkater'));
const Therapiezentrum = lazy(() => import('./seiten/therapiezentrum'));
const SPFH = lazy(() => import('./seiten/spfh'));
const ZARi = lazy(() => import('./seiten/zari'));

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileVersion: false
    };

    /* Alle 2 Stunden die Seite neu laden, wegen TV-App */
    setTimeout(() => window.location.reload(), 7000000);
  }

  componentDidMount() {
    window.onresize = (e) => {
      if (e.target.innerWidth < 1000) {
        if (this.state.mobileVersion === true) {
          return;
        }
        this.setState({ mobileVersion: true });
      } else {
        if (this.state.mobileVersion === false) {
          return;
        }
        this.setState({ mobileVersion: false });
      }
    };

    if (window.innerWidth < 1000) {
      this.setState({ mobileVersion: true });
    }
  }

  checkURL() {
    const path = String(window.location.pathname).toLowerCase();
    return path.toLowerCase().includes("_tv");
  }

  render() {
    const disableNavAndFoot = this.checkURL();

    return (
      <Router basename="/">
        {disableNavAndFoot ? null : <Nav {...this.props} mobileVersion={this.state.mobileVersion} />}

        <div style={disableNavAndFoot ? {} : { marginTop: "70px" }} className="ff-2">
          <Suspense fallback={<div style={{ textAlign: 'center', marginTop: '50px' }}>Lädt...</div>}>
            <Switch>
              <Route exact path="/aktuelles"><Aktuelles {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/alexandra"><Alexandra {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/ambulandbetreuteswohnen"><AmbulandBetreutesWohnen {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/antonia"><Antonia {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/bmh"><BMH {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/datenschutz"><Datenschutz {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/fruehforderung"><Fruehforderung {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/hausamwaldkater"><HausAmWaldkater {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/heilpedagogischekindergarden"><Heilpedagogischekindergarden {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/impressum"><Impressum {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/integrativekindergartengruppe"><IntegrativeKindergartenGruppe {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/katharina"><Katharina {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/kindergarten"><Kindergarten {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/kontakt"><Kontakt {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              {/* <Route exact path="/fahrdienst"><Fahrdienst {...this.props} mobileVersion={this.state.mobileVersion} /></Route> */}
              <Route exact path="/krippe"><Krippe {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/schuleamwaldkater"><SchuleAmWaldkater {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/victoria"><Victoria {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/werkfeuerwehr"><Wekfeuerwehr {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/stallpiraten"><Stallpiraten {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/stellenangebote"><Stellenangebote {...this.props} mobileVersion={this.state.mobileVersion} /></Route>

              <Route exact path="/video_tv"><VideoTv {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/stellenangebote_tv"><StellenangeboteTv {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/eigenewohnung"><EigeneWohnung {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/wohnen"><Wohnen {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/wohntraining"><Wohntraining {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/verein"><Verein {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/tagespflegeamwaldkater"><TagespflegeAmWaldkater {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/therapiezentrum"><Therapiezentrum {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/spfh"><SPFH {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/zari"><ZARi {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
              <Route exact path="/"><Start {...this.props} mobileVersion={this.state.mobileVersion} /></Route>

              <Route path="*"><Start {...this.props} mobileVersion={this.state.mobileVersion} /></Route>
            </Switch>
          </Suspense>
        </div>

        {disableNavAndFoot ? null : <>
          <Footer items={this.props.config.startMenu} />
          <Cookies />
        </>}
      </Router>
    );
  }
}

export default App;
